import React from 'react';
import MainLayout from '../../layouts/MainLayout';
import WorkflowCreatorComponent from '../dashboard/WorflowCreatorComponent';

function WorkflowCreatorView() {
  return (
    <MainLayout>
      <WorkflowCreatorComponent />
    </MainLayout>
  );
}

export default WorkflowCreatorView;
